import getStaffRequest from "./requests/get-staff-request";
import getOneStaffRequest from "./requests/get-one-staff-request";
import generateNewLinkRequest from "./requests/generate-new-link-request";
import updateStaffRequest from "./requests/update-staff-request";
import deleteAvatarRequest from "./requests/delete-avatar-request";
import telegramRequest from "./requests/telegram-request";
import telegramExitRequest from "./requests/telegram-exit-request";
import addStaffRequest from "./requests/add-staff-request";
import deleteStaffRequest from "./requests/delete-staff-request";
import moveUpRequest from "./requests/move-up-request";
import getDataPageRequest from "./requests/get-data-page-request";
import getStaffWithActiveDaysRequest from "./requests/get-staff-with-active-days-request";
import getStaffByServicesRequest from "./requests/get-staff-by-services-request";

const staffRepository = {
    getStaff: getStaffRequest,
    getOneStaff: getOneStaffRequest,
    generateNewLink: generateNewLinkRequest,
    updateStaff: updateStaffRequest,
    deleteAvatar: deleteAvatarRequest,
    telegram: telegramRequest,
    telegramExit: telegramExitRequest,
    addStaff: addStaffRequest,
    deleteStaff: deleteStaffRequest,
    moveUp: moveUpRequest,
    getDataPage: getDataPageRequest,
    getStaffWithActiveDays: getStaffWithActiveDaysRequest,
    getStaffByServices: getStaffByServicesRequest,
};

export default staffRepository;